import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
	name: "users",
	initialState: {
		user: {},
		users: [],
		auth: [],
		offlineMode: false,
		offlineModules: null,
		configId: null,
		offlineConfigCache: null,
		u2fRegistered: false,
	},
	reducers: {
		setUserInf: (state, action) => {
			state.user = action.payload;
			// Check if user has U2F registered from user data
			if (action.payload?.u2fRegistered !== undefined) {
				state.u2fRegistered = action.payload.u2fRegistered;
			}
		},
		setUsers: (state, action) => {
			state.users = action.payload;
		},
		setUserAuth: (state, action) => {
			state.auth = action.payload;
		},
		setU2FRegistered: (state, action) => {
			state.u2fRegistered = action.payload;
		},
		setOfflineMode: (state, action) => {
			state.offlineMode = action.payload;
		},
		setConfigId: (state, action) => {
			state.configId = action.payload;
		},
		setOfflineConfigCache: (state, action) => {
			state.offlineConfigCache = action.payload;
		},
		setOfflineModules: (state, action) => {
			state.offlineModules = action.payload;
		},
	},
});

export const {
	setUserInf,
	setUsers,
	setUserAuth,
	setU2FRegistered,
	setOfflineMode,
	setConfigId,
	setOfflineConfigCache,
	setOfflineModules,
} = userSlice.actions;
export default userSlice.reducer;
